"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var styled_system_1 = require("styled-system");

var ExpanderContext = react_1.default.createContext({
  isOpen: false,
  enabled: [true, true, true, true]
});
exports.ExpanderContext = ExpanderContext;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  overflow: hidden;\n  transition: max-height 0.3s;\n"], ["\n  ", "\n  overflow: hidden;\n  transition: max-height 0.3s;\n"])), styled_system_1.maxHeight);

var Expandable =
/** @class */
function (_super) {
  __extends(Expandable, _super);

  function Expandable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.content = react_1.default.createRef();
    _this.state = {
      height: null,
      isEnabled: true
    };

    _this.getHeight = function (isOpen) {
      return isOpen || _this.state.height === null ? _this.state.height : '0';
    };

    return _this;
  }

  Expandable.prototype.componentDidMount = function () {
    if (this.content.current) {
      this.setState({
        height: this.content.current.getBoundingClientRect().height + "px"
      });
    }
  };

  Expandable.prototype.render = function () {
    var _this = this;

    return react_1.default.createElement(ExpanderContext.Consumer, null, function (_a) {
      var isOpen = _a.isOpen,
          enabled = _a.enabled;
      var maxHeight = Array.isArray(enabled) ? enabled.map(function (isEnabled) {
        return _this.getHeight(!isEnabled || isOpen);
      }) : _this.getHeight(isOpen);
      return react_1.default.createElement(Wrapper, {
        maxHeight: maxHeight
      }, react_1.default.createElement("div", {
        ref: _this.content
      }, _this.props.children));
    });
  };

  return Expandable;
}(react_1.default.Component);

exports.Expandable = Expandable;

var Expander =
/** @class */
function (_super) {
  __extends(Expander, _super);

  function Expander(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      enabled: [],
      isOpen: false,
      toggle: function toggle() {}
    };

    _this.toggle = function () {
      if (!_this.isEnabled()) {
        return;
      }

      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.isEnabled = function () {
      var _a = _this.props,
          theme = _a.theme,
          enabled = _a.enabled;

      if (Array.isArray(enabled)) {
        var breakpoints = theme.breakpoints.map(function (breakpoint) {
          return window.matchMedia("(max-width: " + breakpoint + ")");
        });
        var index = breakpoints.findIndex(function (_a) {
          var matches = _a.matches;
          return matches;
        });
        var lastIndex = enabled.length - 1;
        return enabled[index] || enabled[lastIndex];
      }
    };

    _this.state = {
      toggle: _this.toggle,
      enabled: props.enabled,
      isOpen: props.isOpen ? props.isOpen : false
    };
    return _this;
  }

  Expander.prototype.componentDidMount = function () {
    if (!this.isEnabled()) {
      this.setState({
        isOpen: true
      });
    }
  };

  Expander.prototype.render = function () {
    var children = this.props.children;
    return react_1.default.createElement(ExpanderContext.Provider, {
      value: this.state
    }, children(this.state));
  };

  return Expander;
}(react_1.default.Component);

exports.default = styled_components_1.withTheme(Expander);
var templateObject_1;